import { sdkRequest } from '@eventbrite/http';
import * as Sentry from '@sentry/browser';
import { useCallback } from 'react';
import { formatUrl } from 'url-lib';
import { TimezoneFactory } from './factories';
import { Coordinate, TimezoneDTO, TimezoneValues } from './types';

export const useTimezone = () => {
    const fetchTimezone = useCallback(
        ({ latitude, longitude }: Coordinate): Promise<TimezoneValues> => {
            return sdkRequest(
                formatUrl('/api/v3/system/time_zone_from_coordinates/', {
                    latitude,
                    longitude,
                }),
            )
                .then((timezoneDTO: TimezoneDTO) => {
                    const timezone = createTimezoneAdapter(timezoneDTO);
                    return timezone;
                })
                .catch((error: Error) => {
                    Sentry.captureException(error, {
                        tags: {
                            endpoint:
                                '/api/v3/system/time_zone_from_coordinates/',
                        },
                        extra: {
                            message: 'Error fetching timezone',
                        },
                    });
                    return TimezoneFactory.default();
                });
        },
        [],
    );

    return {
        fetch: fetchTimezone,
    };
};

const createTimezoneAdapter = (timezoneDTO: TimezoneDTO): TimezoneValues => {
    return timezoneDTO;
};
